import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IVendorCompany } from '@/api/types-vendor'

export const defaultItem: IVendorCompany = {
  vendorCompanyId: 0,
  companyName: '',
  companyEmail: '',
  companyPhone: '',
  sameAsVendorAddress: false,
  address: '',
  city: '',
  state: '',
  postalCode: '',
  deleted: false
}

export interface IVendorCompaniesState {
  VendorCompanyList: IVendorCompany[]
  VendorCompanySelected: (IVendorCompany | null)
}

@Module({ dynamic: true, store, name: 'VendorCompanies' })
class VendorCompanies extends VuexModule implements IVendorCompaniesState {
  public VendorCompanyList: IVendorCompany[] = []
  public VendorCompanySelected: IVendorCompany | null = null

  @Mutation
  private DEL_ALL_LIST() {
    this.VendorCompanyList = []
  }

  @Mutation
  private LOAD_LIST(list: IVendorCompany[]) {
    this.VendorCompanyList = list
  }

  @Mutation
  private SET_SELECTED(item: IVendorCompany | null) {
    this.VendorCompanySelected = item
  }

  @Mutation
  private UPDATE_ITEM(item: IVendorCompany) {
    for (let v of this.VendorCompanyList) {
      if (v.vendorCompanyId === item.vendorCompanyId) {
        v = Object.assign(v, item)
        break
      }
    }
  }

  @Action
  public createNewItem(): IVendorCompany {
    const v: IVendorCompany = defaultItem
    v.sameAsVendorAddress = true
    return v
  }

  @Action
  public loadList(list: IVendorCompany[]) {
    this.DEL_ALL_LIST()
    this.LOAD_LIST(list)
  }

  @Action
  public setSelectedItem(item: IVendorCompany) {
    this.SET_SELECTED(item)
  }

  @Action
  public updateItem(item: IVendorCompany) {
    if (this.VendorCompanySelected == null) return
    if (this.VendorCompanySelected.vendorCompanyId !== item.vendorCompanyId) return
    this.SET_SELECTED(item)
    this.UPDATE_ITEM(item)
  }
}

export const VendorCompaniesModule = getModule(VendorCompanies)
